import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import React, { useRef, useState, useEffect, useCallback } from 'react';
import Keyboard from 'react-simple-keyboard';

import { useTranslation } from 'react-i18next';
import 'react-simple-keyboard/build/css/index.css';

import {
  Box,
  Center,
  Stack,
  Title,
  Text,
  Group,
  Container,
  Input,
  Button,
  Paper,
} from '@mantine/core';

// import PrimaryButton from '../../components/GroupButton';

import { sendRequest } from '../../services/services';
import idConfig from '../../services/idConfig';

const UserDetails = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { t } = useTranslation();

  const searchParams = new URLSearchParams(search);
  const PassId = searchParams.get('passId');
  const [shiftButtonText] = useState('Arabic');

  const selectedVas = JSON.parse(localStorage.getItem('selectedVas'));

  const [isEdit, setIsEdit] = useState(false);
  const [inputs, setInputs] = useState({});
  const [layoutName, setLayoutName] = useState('default');
  const [inputName, setInputName] = useState('default');
  const keyboard = useRef();
  const [ticketData, setTicketData] = useState({});
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [touched, setTouched] = useState(false);

  const onChangeAll = (input) => {
    /**
     * Here we spread the inputs into a new object
     * If we modify the same object, react will not trigger a re-render
     */
    setInputs({ ...input });
    setTouched(true);
  };

  // eslint-disable-next-line no-console
  console.log('inputs', inputs);
  const handleShift = () => {
    const newLayoutName = layoutName === 'default' ? 'shift' : 'default';
    setLayoutName(newLayoutName);
  };

  const onKeyPress = (button) => {
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') handleShift();
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;
    setTouched(true);
    setInputs({
      ...inputs,
      [inputName]: inputVal,
    });

    keyboard.current.setInput(inputVal);
    // eslint-disable-next-line no-console
    console.log('Keyboard', keyboard.current.setInput(inputVal));
  };

  const getInputValue = (inputNames) => inputs[inputNames] || '';

  const searchTicket = useCallback(() => {
    sendRequest(`parking/reservations-by-pass-id/${PassId}`, 'get').then((res) => {
      setTicketData(res?.data || []);
    });
  }, [PassId]);

  useEffect(() => {
    searchTicket();
  }, []);

  useEffect(() => {
    if (ticketData?.result?.guest_users === null && ticketData?.result?.customers === null) {
      setIsEdit(true);
    }
  }, [ticketData?.result?.customers, ticketData?.result?.guest_users]);

  const detailsPage = () => {
    navigate({
      pathname: '/addVas',
      search: createSearchParams({
        passId: PassId,
        name: getInputValue('name'),
        mobile: getInputValue('mobile'),
      }).toString(),
    });
  };

  useEffect(() => {
    // Check if ticketData and the respective properties exist
    if (ticketData?.result?.guest_users?.first_name || ticketData?.result?.guest_users?.mobile) {
      setName(ticketData?.result?.guest_users?.first_name);
      setMobile(ticketData?.result?.guest_users?.mobile);
    } else if (ticketData?.result?.customers?.full_name || ticketData?.result?.customers?.mobile) {
      setName(ticketData?.result?.customers?.full_name);
      setMobile(ticketData?.result?.customers?.mobile);
    }
  }, [ticketData]);

  useEffect(() => {
    if (selectedVas === null) {
      navigate({
        pathname: '/',
      });
    }
  });

  // const validConfirm = !!(
  //   ticketData?.result?.guest_users?.mobile ||
  //   ticketData?.result?.customers?.mobile ||
  //   getInputValue('mobile') === null ||
  //   '' ||
  //   undefined
  // );

  const validConfirm =
    ticketData?.result?.guest_users?.mobile ||
    ticketData?.result?.customers?.mobile ||
    inputs?.mobile?.length > 6;

  // eslint-disable-next-line no-console
  console.log(
    'confirm',
    ticketData?.result?.guest_users?.mobile,
    ticketData?.result?.customers?.mobile,
  );

  const handleCancelClick = () => {
    setInputs(''); // Clear the input value
    setIsEdit(false);
  };

  const handleEditClick = () => {
    setIsEdit(true);
    setInputs({
      name: ticketData?.result?.guest_users?.first_name,
      mobile: ticketData?.result?.guest_users?.mobile,
    });
  };

  const showErrorName =
    (touched && getInputValue('name').length < 2) || getInputValue('name').length > 150;

  const showErrorMobile =
    (touched && getInputValue('mobile').length < 7) || getInputValue('mobile').length > 12;

  return (
    <Box style={{ height: 'calc(100vh - 24px)', marginTop: '10px' }}>
      <Stack justify="space-between" style={{ height: '100%' }}>
        <Center>
          <Title style={{ color: '#2C5864' }} order={1}>
            {t('user.details.title.text')}
          </Title>
        </Center>
        <Box style={{ height: 'calc(100vh - 24px)', marginTop: '24px' }}>
          <Box>
            <Container
              className="home"
              style={{
                display: 'flex',
                alignItems: 'stretch',
                flexDirection: 'column',
              }}
            >
              <Center>
                <Paper shadow="sm" sx={{ borderRadius: '10px' }} px="xl">
                  <Text weight={500}>
                    <Center>{t('user.details.service.text')}</Center>
                    {selectedVas ? (
                      <Group>
                        {selectedVas.map((item) => (
                          <Group>
                            {item?.vas_type_id === Number(idConfig.VAS_TYPE_TROLLEY) && (
                              <Title order={3}>{t('choose.service.trolly.title.text')}</Title>
                            )}
                            {item?.vas_type_id === Number(idConfig.VAS_TYPE_SHUTTLE) && (
                              <Title order={3}>{t('choose.service.shuttle.title.text')}</Title>
                            )}
                            {item?.vas_type_id === Number(idConfig.VAS_TYPE_CARWASH) && (
                              <Title order={3}>{t('choose.service.carwash.title.text')}</Title>
                            )}
                            {item?.vas_type_id === Number(idConfig.VAS_TYPE_QUICK_SERVICE) && (
                              <Title order={3}>{t('choose.service.quickservice.title.text')}</Title>
                            )}
                            {item?.vas_sub_type_id === 6 && (
                              <Title order={3}>{t('choose.service.subtype.normal.text')}</Title>
                            )}
                            {item?.vas_sub_type_id === 7 && (
                              <Title order={3}>{t('choose.service.subtype.normal.text')}</Title>
                            )}
                            {item?.vas_sub_type_id === 10 && (
                              <Title order={3}>{t('choose.service.subtype.big.text')}</Title>
                            )}
                            {item?.vas_sub_type_id === 1 && (
                              <Title order={3}>{t('choose.service.carwash.inside.text')}</Title>
                            )}
                            {item?.vas_sub_type_id === 3 && (
                              <Title order={3}>{t('choose.service.carwash.outside.text')}</Title>
                            )}
                          </Group>
                        ))}
                      </Group>
                    ) : null}
                  </Text>
                </Paper>
              </Center>
            </Container>
          </Box>
        </Box>
        <>
          <Box>
            <Container
              className="home"
              style={{
                display: 'flex',
                alignItems: 'stretch',
                flexDirection: 'column',
              }}
            >
              <Stack style={{ color: '#2C5864', marginBottom: '0%' }}>
                <Group position="apart">
                  <Group>
                    <Title style={{ color: '#2C5864', margin: '2% 0' }} order={3}>
                      {t('user.details.name.label')}
                    </Title>

                    {isEdit ? (
                      <Input
                        className="number-input"
                        style={{ direction: 'ltr' }}
                        placeholder={t('user.details.name.label')}
                        size="xl"
                        inputStyles={{
                          width: '60px',
                          height: '50px',
                          fontSize: '2.5rem',
                        }}
                        id="name"
                        value={getInputValue('name')}
                        onFocus={() => setInputName('name')}
                        onChange={onChangeInput}
                      />
                    ) : (
                      <Center py="xl">
                        <Title order={2} py="xl">
                          {name}
                        </Title>
                      </Center>
                    )}
                    {showErrorName && (
                      <Text fz="xs" color="red">
                        Name min 2 and max 150
                      </Text>
                    )}
                  </Group>
                  <Group>
                    <Title style={{ color: '#2C5864', margin: '2% 0' }} order={3}>
                      {t('user.details.mobile.label')}
                    </Title>
                    {isEdit ? (
                      <Input
                        className="number-input"
                        style={{ direction: 'ltr' }}
                        placeholder={t('user.details.mobile.label')}
                        size="xl"
                        inputStyles={{
                          width: '60px',
                          height: '50px',
                          fontSize: '2.5rem',
                        }}
                        id="mobile"
                        value={getInputValue('mobile')}
                        onFocus={() => setInputName('mobile')}
                        onChange={onChangeInput}
                      />
                    ) : (
                      <Title order={2}>{mobile}</Title>
                    )}

                    {showErrorMobile && (
                      <Text fz="xs" color="red">
                        Mobile Number min 7 and max 12
                      </Text>
                    )}
                  </Group>
                  {ticketData?.result?.customers === null && isEdit === false ? (
                    <Button onClick={handleEditClick}>Edit</Button>
                  ) : null}
                  {ticketData?.result?.customers === null && isEdit === true ? (
                    <Button onClick={handleCancelClick}>Cancel</Button>
                  ) : null}
                </Group>
              </Stack>
            </Container>
          </Box>

          <Box py="sm" style={{ direction: 'ltr' }}>
            <Container className="page-specific-keyboard">
              {ticketData?.result?.customers === null ? (
                <Keyboard
                  keyboardRef={(r) => {
                    keyboard.current = r;
                  }}
                  layoutName={layoutName}
                  inputName={inputName}
                  onChangeAll={onChangeAll}
                  onKeyPress={onKeyPress}
                  maxLength={inputName === 'mobile' ? 12 : 150} // Updated maxLength to 12
                  minLength={inputName === 'mobile' ? 7 : 2}
                  theme="hg-theme-default hg-layout-default myTheme"
                  layout={{
                    theme: 'hg-theme-default',
                    default: [
                      '1 2 3 4 5 6 7 8 9 0 {bksp}',
                      'Q W E R T Y U I O P',
                      'A S D F G H J K L',
                      '{shift} Z X C V B N M',
                      '{space}',
                    ],
                    shift: [
                      '\u0630 \u0661 \u0662 \u0663 \u0664 \u0665 \u0666 \u0667 \u0668 \u0669 \u0660 {bksp}',
                      '\u0636 \u0635 \u062B \u0642 \u0641 \u063A \u0639 \u0647 \u062E \u062D \u062C \u062F',
                      '\u0634 \u0633 \u064A \u0628 \u0644 \u0627 \u062A \u0646 \u0645 \u0643 \u0637',
                      '{shift} \u0626 \u0621 \u0624 \u0631 \u0644\u0627 \u0649 \u0629 \u0648 \u0632 \u0638',
                      '{space}',
                    ],
                  }}
                  display={{
                    '{bksp}': '←',
                    '{space}': ' ',
                    '{enter}': shiftButtonText !== 'Arabic' ? 'إرسال' : 'Enter',
                    '{shift}': shiftButtonText !== 'Arabic' ? '&#127760;' : '&#127760;',
                  }}
                />
              ) : null}

              <Center>
                <Button
                  variant="filled"
                  color="teal"
                  radius="lg"
                  fullWidth
                  size="xl"
                  onClick={detailsPage}
                  disabled={!validConfirm}
                  style={{ marginTop: '14px', backgroundColor: '#50A847', width: '48%' }}
                >
                  <Title order={3}>{t('confirm.button.text')}</Title>
                </Button>
              </Center>
            </Container>
            <Box>
              <Container
                className="home"
                style={{
                  display: 'flex',
                  alignItems: 'stretch',
                  flexDirection: 'column',
                }}
              >
                {/* <PrimaryButton /> */}
              </Container>
            </Box>
          </Box>
        </>
      </Stack>
    </Box>
  );
};

export default UserDetails;
